// Module
var code = "<template class=\"a-card__root\"> <div class=\"a-card__container\" ref=\"refContainer\"></div> <slot name=\"header\"></slot> <slot name=\"body\"></slot> <slot name=\"footer\"></slot> </template> ";
// Exports
export default code;